let url = "";

if (process.env.REACT_APP_STAGE === "local") {
    url = "http://localhost:8000";
} else if (process.env.REACT_APP_STAGE === "dev") {
    url = "https://api-dev.optimove.com.br";
} else {
    url = "https://api.optimove.com.br";
}

export const Constants = {
    url,
    baseUrl: url + "/api/closer",
};
